const initialState = {
    address: {lng: 0, lat: 0, textAddress: 'آدرسی پیدا نشد.'},
    profile:{
        fullname: 'کاربر میهمان',
        mobile:'',
        email:'',
    }

};
const guest = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_BASE_ADDRESS_FOR_USERS':
            const address = {lng: action.lng, lat: action.lat, textAddress: action.textAddress};
            return {...state, address: address};
        default:
            return state;
    }
};

export default guest;